import type { Theme } from '@emotion/react';
import { css } from '@emotion/react';

import { breakpoint } from '@twistopayments/design-system/styles';

export const greyIcon = (theme: Theme) => css`
  color: ${theme.palette.tertiary.mediumContrastAlternative};
`;

export const rowListItem = (theme: Theme) => css`
  ${breakpoint.up('md')} {
    margin: ${theme.spacing[16]};
  }
`;

export const noMargin = css`
  margin: 0;

  ${breakpoint.up('sm')} {
    margin: 0;
  }
`;
